
import apiService from "./globalService";

export const HomeService =()=>{
    return{
        getCarouselData:(lang:string)=>{ 
            return apiService.get('/wp-json/home-carousel/v1/slides',
                {params:{
                    lang:lang
                }
            })
        } 
    }
}